import axios from 'axios';
import apiUrl from '../constants';


export function fmsGethublist(token,input){
    return axios({
            method: 'post',
            url: apiUrl.api_url + 'fmsGetHubList',
            data: input,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
}

export function getHubCity(myStr,hubcitydata) {
    return new Promise(async (resolve, reject) => {
        try {
            let input={
                "facilityIds":hubcitydata
              }
            let listOfCity=[]
             fmsGethublist(myStr,input).then(async result => {
         result.data.data.map((city) =>
          (listOfCity[city.HubID] = city.cityName)
      );
      let response = {map:listOfCity}
      return resolve(response.map);
      })
        } catch (e) {
            console.log(`getHubCity-${e.message}`);
        }
    });
   
  }



// WEBPACK FOOTER //
// ./src/services/fmsGethubList.js